module.exports = __webpack_public_path__ + "img/2010 winteressen 005.e984141d.jpg";